import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const TradesMonitoringMock = () => (
  <div className="space-y-4">
    {/* Trades table -- matches TradesTablePanel.tsx */}
    <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
      <div className="p-3">
        <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-3">
          <div className="flex items-center justify-between mb-3">
            <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide">
              Recent Trades
            </h4>
            <span className="text-xs text-cyan-400">View all (5)</span>
          </div>

          <div className="grid grid-cols-6 text-[9px] text-gray-500 uppercase tracking-wider pb-2 border-b border-white/[0.06]">
            <span>Entry</span>
            <span>Price</span>
            <span>Size</span>
            <span>Exit</span>
            <span>PnL</span>
            <span>Status</span>
          </div>

          {[
            { entry: 'Mar 6 14:00', price: '$67,420', size: '0.015', exit: '$68,180', pnl: '+1.13%', pnlColor: 'text-emerald-400', status: 'Closed' },
            { entry: 'Mar 4 02:00', price: '$66,890', size: '0.015', exit: '$67,350', pnl: '+0.69%', pnlColor: 'text-emerald-400', status: 'Closed' },
            { entry: 'Feb 28 18:00', price: '$68,200', size: '0.015', exit: '$67,540', pnl: '-0.97%', pnlColor: 'text-rose-400', status: 'Closed' },
            { entry: 'Feb 25 06:00', price: '$65,100', size: '0.015', exit: '$66,410', pnl: '+2.01%', pnlColor: 'text-emerald-400', status: 'Closed' },
            { entry: 'Feb 22 10:00', price: '$64,750', size: '0.015', exit: '$65,020', pnl: '+0.42%', pnlColor: 'text-emerald-400', status: 'Closed' },
          ].map((t, i) => (
            <div key={i} className="grid grid-cols-6 text-[10px] py-1.5 border-b border-white/[0.03] last:border-0">
              <span className="text-gray-400">{t.entry}</span>
              <span className="text-gray-300">{t.price}</span>
              <span className="text-gray-400">{t.size}</span>
              <span className="text-gray-300">{t.exit}</span>
              <span className={t.pnlColor}>{t.pnl}</span>
              <span className="text-gray-500">{t.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Monitoring Coverage */}
    <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
      <div className="p-3">
        <div className="bg-white/[0.03] rounded-lg p-3 space-y-2">
          <h5 className="text-xs font-medium text-gray-500 uppercase tracking-wide">Adaptive Monitoring Coverage</h5>
          {[
            { label: 'Performance decay monitoring', checked: true },
            { label: 'Sharpe drift detection', checked: true },
            { label: 'Drawdown expansion tracking', checked: true },
            { label: 'Stability breach detection', checked: false },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sm">
              <FontAwesomeIcon
                icon={faCheck}
                className={`w-3 h-3 ${item.checked ? 'text-emerald-400' : 'text-gray-600'}`}
              />
              <span className={item.checked ? 'text-gray-300' : 'text-gray-500'}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default TradesMonitoringMock;
